"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getItemFragment = exports.itemFullFragment = exports.itemFragment = exports.defaultGetterParams = void 0;
const single_line_content_1 = require("./single-line-content");
const rich_text_content_1 = require("./rich-text-content");
const image_content_1 = require("./image-content");
const paragraph_collection_content_1 = require("./paragraph-collection-content");
const item_relations_content_1 = require("./item-relations-content");
const location_content_1 = require("./location-content");
const properties_table_content_1 = require("./properties-table-content");
exports.defaultGetterParams = {
    image: false,
    singleLine: false,
    richText: false,
    paragraphCollection: false,
    itemRelations: false,
    location: false,
};
exports.itemFragment = `
  fragment item on Item {
    id
    name
    type
    path
    components {
      id
      name
      type
      meta {
        key
        value
      }
      content {
        ...singleLineContent
        ...richTextContent
        ...imageContent
        ...paragraphCollectionContent
        ...itemRelationsContent
        ...propertiesTableContent
      }
    }
  }
`;
exports.itemFullFragment = `
  ${exports.itemFragment}
  ${single_line_content_1.singleLineContentFragment}
  ${rich_text_content_1.richTextContentFragment}
  ${image_content_1.imageContentFragment}
  ${paragraph_collection_content_1.paragraphCollectionContentFragment}
  ${item_relations_content_1.itemRelationsContentFragment}
  ${properties_table_content_1.propertiesTableContentFragment}
`;
const getItemFragment = (params = exports.defaultGetterParams) => `
  fragment item on Item {
    id
    name
    type
    path
    components {
      id
      name
      type
      meta {
        key
        value
      }
      content {
        ${params.singleLine ? '...singleLineContent' : ''}
        ${params.richText ? '...richTextContent' : ''}
        ${params.image ? '...imageContent' : ''}
        ${params.paragraphCollection ? '...paragraphCollectionContent' : ''}
        ${params.itemRelations ? '...itemRelationsContent' : ''}
        ${params.location ? '...locationContent' : ''}
      }
    }
  }
  ${params.singleLine ? single_line_content_1.singleLineContentFragment : ''}
  ${params.richText ? rich_text_content_1.richTextContentFragment : ''}
  ${params.image ? image_content_1.imageContentFragment : ''}
  ${params.paragraphCollection ? paragraph_collection_content_1.paragraphCollectionContentFragment : ''}
  ${params.itemRelations ? item_relations_content_1.itemRelationsContentFragment : ''}
  ${params.location ? location_content_1.locationContentFragment : ''}
`;
exports.getItemFragment = getItemFragment;
//# sourceMappingURL=item.js.map